// src/client/auth/KycGuard.tsx
// Borrowers must complete KYC before reaching the dashboard. This guard sits
// inside ProtectedRoute, between auth and feature routes.
import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { useAuth } from './useAuth';

export function KycGuard() {
  const { profile, status } = useAuth();

  // While auth is still resolving, show nothing (ProtectedRoute already
  // renders "Loading…" for status === 'loading' before we're reached).
  // If status is signed_in but profile is unexpectedly null (e.g. a transient
  // DB error), redirect to KYC rather than hanging forever — the user can
  // re-submit or retry from there.
  if (!profile) {
    if (status === 'loading') return null;
    return <Navigate to={ROUTES.kyc} replace />;
  }
  if (profile.kyc_status !== 'verified') {
    return <Navigate to={ROUTES.kyc} replace />;
  }
  return <Outlet />;
}
